import React, { useEffect, useRef } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';



export default function Hero() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animId;
    const particles = [];

    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < 70; i++) {
      particles.push({
        x: Math.random() * canvas.width, y: Math.random() * canvas.height,
        r: Math.random() * 1.4 + 0.3,
        dx: (Math.random() - 0.5) * 0.25, dy: (Math.random() - 0.5) * 0.25,
        opacity: Math.random() * 0.45 + 0.1,
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(37,138,203,${p.opacity})`; ctx.fill();
        p.x += p.dx; p.y += p.dy;
        if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
      });
      particles.forEach((p, i) => {
        particles.slice(i + 1).forEach(q => {
          const d = Math.hypot(p.x - q.x, p.y - q.y);
          if (d < 110) {
            ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y);
            ctx.strokeStyle = `rgba(37,138,203,${0.07 * (1 - d / 110)})`;
            ctx.lineWidth = 0.5; ctx.stroke();
          }
        });
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);

  return (
    <section id="home" style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', overflow: 'hidden', paddingTop: '80px' }}>
      <canvas ref={canvasRef} style={{ position: 'absolute', inset: 0, zIndex: 0, opacity: 0.65 }} />
      <div style={{ position: 'absolute', width: '700px', height: '700px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(37,138,203,0.16) 0%, transparent 70%)', top: '-150px', left: '-150px', filter: 'blur(60px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(37,138,203,0.1) 0%, transparent 70%)', bottom: '0', right: '5%', filter: 'blur(60px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', inset: 0, zIndex: 0, backgroundImage: 'linear-gradient(rgba(37,138,203,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(37,138,203,0.03) 1px, transparent 1px)', backgroundSize: '80px 80px' }} />

      <div className="container" style={{ position: 'relative', zIndex: 1, paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div style={{ maxWidth: '840px' }}>
     
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2.8rem, 6vw, 5.5rem)', fontWeight: 800, lineHeight: 1.0, marginBottom: '1.5rem', animation: 'fadeInUp 0.9s ease 0.1s both' }}>
            Engineering{' '}<span className="gradient-text">Intelligent</span>
            <br />Digital Products
            <br /><span style={{ color: 'var(--accent)' }}>&</span>{' '}AI Solutions
          </h1>
          <p style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: 'var(--text-secondary)', maxWidth: '600px', lineHeight: 1.75, marginBottom: '2.5rem', animation: 'fadeInUp 0.9s ease 0.2s both' }}>
            Web Development, Mobile Apps, DevOps, Cloud Engineering, Agentic AI & Generative AI for modern businesses that demand scale and precision.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', animation: 'fadeInUp 0.9s ease 0.3s both' }}>
            <a href="#contact" className="btn-primary" style={{ fontSize: '1rem', padding: '0.95rem 2.2rem' }}>
              Get Free Consultation <ArrowRight size={18} />
            </a>
            <a href="#services" className="btn-ghost" style={{ fontSize: '1rem', padding: '0.95rem 2.2rem' }}>
              View Services
            </a>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2.5rem', marginTop: '4rem', paddingTop: '2.5rem', borderTop: '1px solid var(--border)', animation: 'fadeInUp 0.9s ease 0.4s both' }}>
            {[{ num: '50+', label: 'Projects Delivered' }, { num: '30+', label: 'Happy Clients' }, { num: '5+', label: 'Years Experience' }, { num: '99%', label: 'Client Satisfaction' }].map(stat => (
              <div key={stat.label}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 800, color: 'var(--accent)', lineHeight: 1 }}>{stat.num}</div>
                <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', marginTop: '0.3rem' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <a href="#about" style={{ position: 'absolute', bottom: '2rem', left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'var(--text-muted)', textDecoration: 'none', animation: 'bounce 2s infinite' }}>
        <ChevronDown size={20} />
      </a>

      <style>{`
        @keyframes fadeInUp { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:none} }
        @keyframes bounce { 0%,100%{transform:translateX(-50%) translateY(0)} 50%{transform:translateX(-50%) translateY(6px)} }
      `}</style>
    </section>
  );
}